import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Albuquerque = () => {
  const nearbyFacilities = [
    { name: 'Western Refining', type: 'Refinery', capacity: '27,000 BPD' },
    { name: 'Kirtland Air Force Base', type: 'Military Industrial', capacity: 'Major Facility' },
    { name: 'Manufacturing Plants', type: 'Industrial', capacity: '100+ Facilities' },
    { name: 'Sandia National Labs', type: 'Research/Industrial', capacity: 'Advanced Tech' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Albuquerque refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Albuquerque refineries including Western Refining and manufacturing facilities. We provide 6-8 hour response times with competitive pricing for New Mexico facilities."
    },
    {
      question: "What types of equipment do you buy in Albuquerque?",
      answer: "We buy control valves, ball valves, gate valves, globe valves, heat exchangers, pumps, compressors, safety systems, Rosemount transmitters, flow meters, analyzers, and controllers from Albuquerque industrial facilities."
    },
    {
      question: "How quickly can you respond to Albuquerque facilities?",
      answer: "We provide 6-8 hour response times for Albuquerque and surrounding New Mexico facilities. Our team has 20+ years of experience serving New Mexico's diverse industrial and technology sectors."
    },
    {
      question: "Do you purchase equipment from Albuquerque manufacturing plants?",
      answer: "Yes, we buy industrial equipment and instrumentation from Albuquerque's 100+ manufacturing facilities. We provide professional valuations for process equipment and control systems."
    },
    {
      question: "What valve brands do you buy from Albuquerque facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Albuquerque refineries, manufacturing plants, and industrial facilities."
    },
    {
      question: "Do you serve other New Mexico cities from Albuquerque?",
      answer: "Yes, our Albuquerque service area covers all of New Mexico including Artesia, Roswell, Hobbs, and other oil and gas regions. We provide fast response times throughout the state."
    }
  ];

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://valvesalessupply.com/albuquerque",
        "url": "https://valvesalessupply.com/albuquerque",
        "name": "Albuquerque Valve Buyers New Mexico | Industrial Equipment",
        "description": "Professional valve buyers in Albuquerque serving New Mexico industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "New Mexico",
              "item": "https://valvesalessupply.com/new-mexico"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Albuquerque",
              "item": "https://valvesalessupply.com/albuquerque"
            }
          ]
        }
      },
      {
        "@type": "LocalBusiness",
        "name": "Valve Sales Supply - Albuquerque",
        "image": "https://valvesalessupply.com/logo.png",
        "@id": "https://valvesalessupply.com/albuquerque",
        "url": "https://valvesalessupply.com/albuquerque",
        "telephone": "214-854-5638",
        "priceRange": "$$",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Albuquerque",
          "addressRegion": "NM",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 35.0844,
          "longitude": -106.6504
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "17:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "09:00",
            "closes": "14:00"
          }
        ],
        "areaServed": [
          {
            "@type": "City",
            "name": "Albuquerque",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Rio Rancho",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Santa Fe",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Los Lunas",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Industrial Equipment Purchasing Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Fisher Control Valves Purchase",
                "description": "Professional purchasing of Fisher control valves from Albuquerque industrial facilities at above scrap rates"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Rosemount Instrumentation Purchase",
                "description": "Expert evaluation and purchase of Rosemount transmitters and instrumentation from New Mexico facilities"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Process Equipment Purchase",
                "description": "Complete purchasing services for heat exchangers, pumps, compressors, and safety systems"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Manufacturing Equipment Purchase",
                "description": "Professional equipment purchasing from Albuquerque's 100+ manufacturing facilities"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Turnaround Coordination",
                "description": "Fast response turnaround coordination for Albuquerque industrial facilities with complete compliance documentation"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Emergency Equipment Removal",
                "description": "6-8 hour response time for urgent equipment removal and purchasing in Albuquerque area"
              }
            }
          ]
        }
      },
      {
        "@type": "Service",
        "serviceType": "Industrial Valve and Equipment Purchasing",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Albuquerque"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Albuquerque"
          },
          {
            "@type": "City",
            "name": "Rio Rancho"
          },
          {
            "@type": "City",
            "name": "Santa Fe"
          },
          {
            "@type": "City",
            "name": "Los Lunas"
          },
          {
            "@type": "City",
            "name": "Belen"
          },
          {
            "@type": "City",
            "name": "Bernalillo"
          }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Equipment Categories",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Fisher Control Valves",
                "description": "Fisher control valves, regulators, and actuators from Albuquerque facilities"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Ball and Gate Valves",
                "description": "Industrial ball valves, gate valves, globe valves, and check valves"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Rosemount Instrumentation",
                "description": "Rosemount transmitters, flow meters, analyzers, and controllers"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Process Equipment",
                "description": "Heat exchangers, pumps, compressors, and safety systems"
              }
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": faqData.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }
    ]
  };

  useEffect(() => {
    // Set page title
    document.title = "Albuquerque Valve Buyers New Mexico | Industrial Equipment";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional valve buyers in Albuquerque serving New Mexico industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Professional valve buyers in Albuquerque serving New Mexico industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'valve buyers Albuquerque, New Mexico equipment, surplus valves, Fisher control valves, refinery equipment');

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/albuquerque');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Albuquerque Valve Buyers New Mexico | Industrial Equipment' },
      { property: 'og:description', content: 'Professional valve buyers in Albuquerque serving New Mexico industrial facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/albuquerque' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '35.0844;-106.6504' },
      { name: 'geo.placename', content: 'Albuquerque, New Mexico' },
      { name: 'geo.region', content: 'US-NM' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/168038cd316e33ae6e5c5cc4cf1d9cd2.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Albuquerque</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional <strong>valve buyers in Albuquerque</strong> serving New Mexico industrial facilities. 
              Valve Sales Supply purchases surplus valves, control systems, and instrumentation from Albuquerque 
              refineries and manufacturing plants at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET ALBUQUERQUE QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">ALBUQUERQUE INDUSTRIAL EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Albuquerque serves as New Mexico's industrial and technology hub with diverse manufacturing and 
                research facilities. As experienced <strong className="text-[#1B3A5F]">surplus valve buyers in Albuquerque</strong>, 
                we provide professional equipment purchasing services for all industrial sectors.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount transmitters, and complete instrumentation systems from Albuquerque industrial facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">100+</div>
                  <div className="text-gray-600">Industrial Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-8 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">20 Years</div>
                  <div className="text-gray-600">NM Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">ALBUQUERQUE FACILITIES</h3>
              <div className="space-y-4">
                {nearbyFacilities.map((facility, index) => (
                  <div key={index} className="bg-white rounded-lg p-4">
                    <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                    <div className="flex justify-between mt-2">
                      <span className="text-gray-600 text-sm">{facility.type}</span>
                      <span className="text-[#1B3A5F] font-semibold text-sm">{facility.capacity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES ALBUQUERQUE NM</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Albuquerque industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Control Valves',
                equipment: ['Fisher Control Valves', 'Masoneilan Valves', 'Ball Valves', 'Gate Valves', 'Globe Valves'],
                description: 'Premium control valves from Albuquerque facilities'
              },
              {
                title: 'Process Equipment',
                equipment: ['Heat Exchangers', 'Pumps', 'Compressors', 'Safety Systems'],
                description: 'Industrial equipment from manufacturing plants'
              },
              {
                title: 'Instrumentation',
                equipment: ['Rosemount Transmitters', 'Flow Meters', 'Analyzers', 'Controllers'],
                description: 'Process instrumentation from New Mexico facilities'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{category.title}</h3>
                <p className="text-gray-600 mb-6">{category.description}</p>
                
                <div className="space-y-3">
                  {category.equipment.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">RELATED NEW MEXICO MARKETS</h2>
            <p className="text-gray-600 text-xl">We serve all major New Mexico industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { city: 'Artesia', link: '/artesia' },
              { city: 'Roswell', link: '/roswell' },
              { city: 'Hobbs', link: '/hobbs' }
            ].map((market, index) => (
              <Link
                key={index}
                to={market.link}
                className="bg-[#F5F7FA] rounded-xl p-6 text-center hover:shadow-lg hover:bg-white transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
              >
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{market.city}</h3>
                <div className="text-gray-600 text-sm mb-3">NM Valve Buyers</div>
                <div className="text-[#1B3A5F] font-semibold inline-flex items-center">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/new-mexico"
              className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center text-lg"
            >
              View All New Mexico Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">ALBUQUERQUE EQUIPMENT BUYER</h2>
              <p className="text-xl text-gray-200 mb-8">
                Contact Mark Driver for professional equipment purchasing services in Albuquerque
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold text-xl">214-854-5638</div>
                    <div className="text-gray-300">Direct Line - Mark Driver</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold">albuquerque@valvesalessupply.com</div>
                    <div className="text-gray-300">Equipment Lists & Photos</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WHY CHOOSE VALVE SALES SUPPLY</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast 6-8 hour response in Albuquerque',
                  'Expert knowledge of industrial equipment',
                  'Professional turnaround coordination',
                  'Complete compliance documentation',
                  '20+ years New Mexico market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] text-xl mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center w-full whitespace-nowrap"
                >
                  GET QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">ALBUQUERQUE VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Albuquerque;